define('home/views/ThreadCardDefaultFooterView',[
    'backbone-marionette',

    'home/models/Session',
    'home/templates/threadCardDefaultFooter',
    'home/mixins/withThreadSharing',
], function (
    Marionette,

    Session,
    threadCardDefaultFooterTemplate,
    withThreadSharing
) {
    'use strict';

    /**
     * The default footer view for cards backed by a thread. Shows
     * basic actions.
     *
     * Expects a thread as the model. Channel is optional.
     */
    var ThreadCardDefaultFooterView = Marionette.ItemView.extend({
        template: threadCardDefaultFooterTemplate,
        templateHelpers: function () {
            var session = Session.get();

            return {
                favorited: this.model.get('userScore') > 0,
                discussionRoute: this.model.getDiscussionRoute(this.channel),
                authenticated: !session.isAnonymous(),
                likes: this.model.get('likes'),
            };
        },

        events: {
            'click [data-action=favorite]': 'toggleThreadFavorited',
            'click [data-action=toggle-subscription]': 'toggleSubscription',
        },

        initialize: function (options) {
            this.listenTo(this.model, 'change:userScore', this.render);
            this.listenTo(this.model, 'change:userSubscription', this.render);
            this.channel = options && options.channel;
        },

        toggleThreadFavorited: function (event) {
            if (event)
                event.preventDefault();

            this.model.toggleFavorited();
        },

        toggleSubscription: function (event) {
            if (event)
                event.preventDefault();

            this.model.toggleSubscription();
        },
    });

    withThreadSharing.call(ThreadCardDefaultFooterView.prototype);

    return ThreadCardDefaultFooterView;
});

